/* ============
 * Courses Module
 * ============
 */

import state from './state';
import accountState from '../account/state';
import mutations from './mutations';
import getters from './getters';

export default {
  state,
  accountState,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/app/store/modules/courses/index.js